import { useEffect, useState } from 'react'
import { Button, CircularProgress, Dialog, DialogTitle } from '@mui/material'
import axios from 'axios'
import { format } from 'date-fns'
import ReactGA from 'react-ga4'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants, Channel, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { studio } from 'redux/persist'
import { SetSelectedStudioReferral } from 'redux/Referral/persist'
import { useAppDispatch, useAppSelector } from 'redux/store'
import styles from './SelectStudio.module.scss'

const SelectStudioReferral = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const studios = useAppSelector((state) => state.referralPersist.studiosReferral)
  const selectedStudio = useAppSelector((state) => state.referralPersist.studioReferral)
  const isMoreThanOneStudio = useAppSelector((state) => state.referralPersist.isMoreThanOneStudioReferral)
  const plan = useAppSelector((state) => state.referralPersist.paymentPlanReferral)

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        {
          stage: LeadStage.location,
          channel: plan && plan?.length > 0 ? (plan[0]?.amount > 0 ? Channel.referral : Channel.free) : null,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    ReactGA.event('page_view', {
      page_title: 'select-studio',
      page_location: `/referral/${id}/select-studio`,
    })
  }, [])

  console.log(studios, 'this is the list of studios')

  return (
    <>
      <div className={styles.container}>
        {/* <Header
          headerText="Select Location"
          showBackButton={false}
          // onBack={() => {
          //   navigate('/choose-plan')
          // }}
        ></Header> */}
        <div className={styles.header}>
          <div className={styles.headerText}>
            <span>{'Select the location that'}</span>
            <span>{`works best for you.`}</span>
          </div>
          <img src={'/logo2.png'} alt="logo" className={styles.logo} />
        </div>
        <div className={styles.locationWrapper} style={{ cursor: 'pointer' }}>
          {studios &&
            studios.map((s: studio) => {
              return (
                <div
                  className={styles.locationContainer}
                  style={{
                    background: selectedStudio && selectedStudio.id === s.id ? 'var(--color-primary)' : 'transparent',
                    border:
                      selectedStudio && selectedStudio.id === s.id
                        ? '1px solid var(--color-primary)'
                        : '1px solid var(--color-border-primary)',
                    color:
                      selectedStudio && selectedStudio.id === s.id
                        ? 'var(--color-text-secondary)'
                        : 'var(--color-text-primary)',
                  }}
                  key={s.id}
                  onClick={() => {
                    dispatch(SetSelectedStudioReferral(s))
                  }}
                >
                  <div className={styles.locationDetails}>
                    <div className={styles.locationTextContainer}>
                      <div className={styles.locationTextWrapper}>
                        <div className={styles.locationName}>{s.name}</div>
                        <div>
                          <div className={styles.locationText}>{s.address}</div>
                          <div className={styles.cityAndState}>
                            <div style={{ marginRight: '4px' }}>{s.city.name + ','}</div>
                            <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{s.state}</div>
                            <div>{s.zipCode}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      style={{
                        // width: '126px',
                        // height: '95.9px',
                        cursor: 'pointer',
                        objectFit: 'cover',
                      }}
                      className={styles.mapImageItem}
                      src={s?.mapImage ? s.mapImage : ''}
                      alt="map"
                      // onClick={() => {
                      //   if (s?.mapLocation) {
                      //     window.open(s?.mapLocation, '_blank')
                      //   }
                      // }}
                    />
                  </div>
                </div>
              )
            })}
        </div>

        <Footer
          buttonText={'Continue'}
          isLoading={false}
          trackerIndex={3}
          shouldShowFour={true}
          shouldShowFive={true}
          shouldShowSix={isMoreThanOneStudio}
          isDisabled={!selectedStudio}
          buttonType={'button'}
          onButtonClick={() => {
            if (selectedStudio) {
              navigate(`/referral/${id}/physical-visit`)
            }
          }}
        ></Footer>
      </div>
    </>
  )
}

export default SelectStudioReferral
